<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>

<header class="position-absolute top-0 start-0 end-0 mt-3 mx-3">
    <div class="d-flex d-lg-none justify-content-center" *ngIf="isProdction">
        <a routerLink="/{{mainPath}}/Dashboard">
        <img class="w-100" [src]="logoPicSrc" alt="Image Description" data-hs-theme-appearance="default" style="min-width: 7rem; max-width: 8.5rem;">
        </a>
    </div>
    </header>


   <main id="content" role="main" class="main">

    <div class="container-fluid" style="padding-right: 1rem;padding-left: 0.5rem;">
        <div class="row">

           <div class="col-lg-6 d-flex flex-column justify-content-center align-items-center min-vh-lg-100 position-relative">

    <!-- شريط اللغة واللوجو أعلى الكولم -->
    <div class="d-flex justify-content-between align-items-center w-100 px-3 position-absolute top-0 pt-3">
        
        <!-- زر اللغة - أقصى اليسار -->
           <a routerLink="/{{mainPath}}/Dashboard">
            <img [src]="logoPicSrc" alt="Logo" style="min-width: 7rem; max-width: 8.5rem;">
        </a>
       

        <!-- اللوجو - أقصى اليمين -->
          <div style="cursor: pointer;" class="svg-word-icon" role="button" (click)="changeLanguage()">
            <svg role="button" style="width: 25px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                <path d="M53.85 47.85A27 27 0 0 1 24 57.8V56l3-3v-4l4-4v-3l4 4h5l2-2h8z"/>
                <path d="M42 20.59v2.56L38.07 27H31l-5.36 5.26L31 37.51v5.06L27.44 39h-4.58L16 32.11V24.2L11.8 20h-4A27 27 0 0 1 32 5a26.55 26.55 0 0 1 7.06.94L36 9h-6v4l4 4h4.33z"/>
                <path d="M32 60a28 28 0 1 1 28-28 28 28 0 0 1-28 28zm0-54a26 26 0 1 0 26 26A26 26 0 0 0 32 6z"/>
            </svg>
            <span role="button" class="mx-2">{{'lang'|translate}}</span>
        </div>
      

    </div>

    <!-- الفورم - بدون أي تغيير -->
    <div class="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1" style="max-width: 25rem;">
        <form #myForm="ngForm" (ngSubmit)="login()">
        
            <div class="text-center">
                <div class="mb-5">
                    <h1 class="display-4">{{'login'|translate}}</h1>
                    @if(mainPath=='Investment'){
                        <p>{{'newUser'|translate}} <a class="link" routerLink="/{{mainPath}}/SignUp" role="button">{{'createAccount'|translate}}</a></p>
                    }
                </div>
            </div>

            <div class="mb-4">
                <div class="mb-3 field-loginform-password required">
                    <label class="form-label" for="loginform-password">{{'natNumber'|translate}}</label>
                    <input name="username" id="username" [(ngModel)]="username" #username_field="ngModel" class="form-control"
                        [attr.inputmode]="mainPath === 'HCD' ? 'numeric' : null"
                        [attr.pattern]="mainPath === 'HCD' ? '[0-9]*' : null"
                        (input)="onUsernameInput($event)" required="true">
                    <span class="text-danger" *ngIf="myForm.submitted && !username_field.valid">{{'requiredField'|translate}}!</span>
                </div>
            </div>

            <div class="mb-4">
                <div class="mb-3 field-loginform-password required">
                    <label class="form-label" for="loginform-password">{{'password'|translate}}</label>
                    <input type="password" name="password" id="password" [(ngModel)]="password" #password_field="ngModel" required="true" class="form-control">
                    <span class="text-danger" *ngIf="myForm.submitted && !password_field.valid">{{'requiredField'|translate}}!</span>
                </div>
            </div>

            <br>

            @if(mainPath=='Investment'){
                <div class="my-1 mx-0" style="color:#999;">
                    {{'forgetPasswordRequest'|translate}}<a routerLink="/{{mainPath}}/ForgetPassword">{{'forgetPasswordRequestApply'|translate}}</a>.
                </div>
            }

            <div class="d-grid gap-2 mt-3">
                <button type="submit" class="btn btn-primary btn-lg" [disabled]="isLoading">
                    {{'applyLogin'|translate}}
                </button>
            </div>

            @if(mainPath != 'Investment'){
                <br>
                <br>
                <div class="text-center" style="padding: 10px; border: 1px solid #edd; margin-left:40px; margin-right:40px">
                    <img style="width:100px; height:70px;margin-bottom: 10px;" src="/assets/images/sanad.png">
                    <p>{{'sanad_loginDesc'|translate}}</p>
                </div>
            }

            <div *ngIf="mainPath === 'Investment'" class="row text-center mt-3">
                <div class="mt-3 col-12" *ngIf="lang=='ar'">
                    <a href="../../../assets/UserManual/Arabic.pdf" target="_blank">
                        دليل المستخدم <i class="fa fa-download"></i>
                    </a>
                </div>
                <div class="mt-3 col-12" *ngIf="lang=='ar'">
                    <a href="../../../assets/UserManual/الحوافز والاعفاءات - خارج التنموي.pdf" target="_blank">
                        دليل التقدم بطلب إعفاءات وحوافز <i class="fa fa-download"></i>
                    </a>
                </div>
                <div class="mt-3 col-12" *ngIf="lang=='en'">
                    <a href="../../../assets/UserManual/English guide.pdf" target="_blank">
                        User manual 1 <i class="fa fa-download"></i>
                    </a>
                </div>
            </div>

        </form>
    </div>

</div>

           <div
  class="col-lg-6 d-none d-lg-flex justify-content-center min-vh-lg-100 position-relative px-0"
  [ngStyle]="{
    'background-image': 'url(' + backGroundImageSrc + ')',
    'background-size': 'cover',
    'background-position': 'center'
  }">

            <div class="card pt-md-7 blur px-5 pb-10" *ngIf="isProdction"
                style="margin-top: 10.5rem;max-width: 23rem;max-height: 23rem;">
                <div class="text-center mb-5">
                    <img class="img-fluid" [src]="logoPicSrc" alt="Image Description" style="width: 12rem;" data-hs-theme-appearance="default">
                </div>
                <div class="mb-5">
                    <h2 class="display-5 text-center">
                        {{'investmentLoginDesc'|translate}}
                    </h2>
                </div>


            </div>
        </div>

        </div>

    </div>
